import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Assessment = {
  __typename?: 'Assessment';
  args?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<AssessmentMetadata>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  template: AssessmentTemplate;
};

export type AssessmentEducationMetadata = {
  __typename?: 'AssessmentEducationMetadata';
  degree?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  institutionName: Scalars['String']['output'];
  major: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type AssessmentFeedback = {
  __typename?: 'AssessmentFeedback';
  assessmentId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  technicalDifficultyResolvedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssessmentLanguageMetadata = {
  __typename?: 'AssessmentLanguageMetadata';
  language: Scalars['String']['output'];
  proficiency: Scalars['String']['output'];
};

export type AssessmentMetadata = {
  __typename?: 'AssessmentMetadata';
  talentScout: AssessmentTalentScoutMetadata;
  user: AssessmentUserMetadata;
};

export type AssessmentResearchPaperMetadata = {
  __typename?: 'AssessmentResearchPaperMetadata';
  fileName: Scalars['String']['output'];
  fullGcsUrl: Scalars['String']['output'];
  gcsUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AssessmentTalentScoutMetadata = {
  __typename?: 'AssessmentTalentScoutMetadata';
  disciplines: Array<Scalars['String']['output']>;
  specializations: Array<Scalars['String']['output']>;
};

export type AssessmentTemplate = {
  __typename?: 'AssessmentTemplate';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  filteredAttributes?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  templateType: AssessmentType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum AssessmentType {
  CodeReview = 'code_review',
  GithubCoding = 'github_coding',
  Interview = 'interview',
  LiveCoding = 'live_coding',
  RlEnvironment = 'rl_environment'
}

export type AssessmentUserMetadata = {
  __typename?: 'AssessmentUserMetadata';
  education: Array<AssessmentEducationMetadata>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  languages: Array<AssessmentLanguageMetadata>;
  programmingLanguages: Array<AssessmentLanguageMetadata>;
  researchPapers?: Maybe<Array<AssessmentResearchPaperMetadata>>;
  resumeUri?: Maybe<Scalars['String']['output']>;
  skills: Array<Scalars['String']['output']>;
  workExperiences: Array<AssessmentWorkExperienceMetadata>;
};

export type AssessmentWorkExperienceMetadata = {
  __typename?: 'AssessmentWorkExperienceMetadata';
  employerName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type AuthenticateWithInviteCodeResult = {
  __typename?: 'AuthenticateWithInviteCodeResult';
  token: Scalars['String']['output'];
};

export type CodeExecution = {
  __typename?: 'CodeExecution';
  assessmentId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  entrypoint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  language: Scalars['String']['output'];
  output: Scalars['String']['output'];
  passingTestCases: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  totalTestCases: Scalars['Int']['output'];
};

export type CodeReviewComment = {
  __typename?: 'CodeReviewComment';
  assessmentId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lineNumber: Scalars['Int']['output'];
  side: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompleteAssessmentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCodeReviewCommentInput = {
  id: Scalars['ID']['input'];
};

export type ExecuteCodeAgainstTestCasesInput = {
  code: Scalars['String']['input'];
};

export type ExecutionResult = {
  __typename?: 'ExecutionResult';
  exitCode: Scalars['Int']['output'];
  status: ExecutionStatus;
  stderr: Scalars['String']['output'];
  stdout: Scalars['String']['output'];
};

export enum ExecutionStatus {
  Error = 'Error',
  Success = 'Success',
  Timeout = 'Timeout'
}

export type GitHubCommit = {
  __typename?: 'GitHubCommit';
  author: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  latestWorkflowRun?: Maybe<GitHubWorkflowRun>;
  message: Scalars['String']['output'];
  sha: Scalars['String']['output'];
};

export type GitHubProvisioning = {
  __typename?: 'GitHubProvisioning';
  assessmentId: Scalars['ID']['output'];
  commits: Array<GitHubCommit>;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  repoName?: Maybe<Scalars['String']['output']>;
  repoUrl?: Maybe<Scalars['String']['output']>;
  status: GitHubProvisioningStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum GitHubProvisioningError {
  CleanupFailed = 'CleanupFailed',
  CreateRepoFailed = 'CreateRepoFailed',
  GithubUserNotFound = 'GithubUserNotFound',
  UserInviteFailed = 'UserInviteFailed'
}

export type GitHubProvisioningInput = {
  assessmentId: Scalars['ID']['input'];
  sync?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GitHubProvisioningStatus {
  Completed = 'Completed',
  Error = 'Error',
  RepoCreated = 'RepoCreated',
  Started = 'Started',
  UserInviteAccepted = 'UserInviteAccepted',
  UserInviteSent = 'UserInviteSent',
  UserPushedCode = 'UserPushedCode'
}

export type GitHubWorkflowRun = {
  __typename?: 'GitHubWorkflowRun';
  conclusion?: Maybe<GitHubWorkflowRunConclusion>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: GitHubWorkflowRunStatus;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export enum GitHubWorkflowRunConclusion {
  ActionRequired = 'action_required',
  Cancelled = 'cancelled',
  Failure = 'failure',
  Neutral = 'neutral',
  Skipped = 'skipped',
  Success = 'success',
  TimedOut = 'timed_out'
}

export enum GitHubWorkflowRunStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  Queued = 'queued'
}

export type Mutation = {
  __typename?: 'Mutation';
  authenticateWithInviteCode: AuthenticateWithInviteCodeResult;
  completeAssessment: Scalars['ID']['output'];
  deleteCodeReviewComment: Scalars['ID']['output'];
  runRlEnvironmentRound: RlEnvironmentRound;
  startAssessment: Scalars['ID']['output'];
  submitCodeReviewComment: CodeReviewComment;
  updateCodeReviewComment: CodeReviewComment;
  upsertAssessmentFeedback: AssessmentFeedback;
  upsertRlEnvironment: RlEnvironment;
};


export type MutationAuthenticateWithInviteCodeArgs = {
  inviteCode: Scalars['String']['input'];
};


export type MutationCompleteAssessmentArgs = {
  input: CompleteAssessmentInput;
};


export type MutationDeleteCodeReviewCommentArgs = {
  input: DeleteCodeReviewCommentInput;
};


export type MutationStartAssessmentArgs = {
  input: StartAssessmentInput;
};


export type MutationSubmitCodeReviewCommentArgs = {
  input: SubmitCodeReviewCommentInput;
};


export type MutationUpdateCodeReviewCommentArgs = {
  input: UpdateCodeReviewCommentInput;
};


export type MutationUpsertAssessmentFeedbackArgs = {
  input: UpsertAssessmentFeedbackInput;
};


export type MutationUpsertRlEnvironmentArgs = {
  input: UpsertRlEnvironmentInput;
};

export type Query = {
  __typename?: 'Query';
  assessment?: Maybe<Assessment>;
  assessmentFeedback?: Maybe<AssessmentFeedback>;
  executeCodeAgainstTestCases: ExecutionResult;
  getCodeReviewComments: Array<CodeReviewComment>;
  getLatestCodeExecution?: Maybe<CodeExecution>;
  getRlEnvironment: RlEnvironment;
  getRlEnvironmentResult?: Maybe<RlEnvironmentResult>;
  gitHubProvisioning?: Maybe<GitHubProvisioning>;
};


export type QueryAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentFeedbackArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type QueryExecuteCodeAgainstTestCasesArgs = {
  input: ExecuteCodeAgainstTestCasesInput;
};


export type QueryGitHubProvisioningArgs = {
  input?: InputMaybe<GitHubProvisioningInput>;
};

export type RlEnvironment = {
  __typename?: 'RlEnvironment';
  assessmentId: Scalars['ID']['output'];
  files: Array<RlEnvironmentFile>;
  grader: Scalars['JSON']['output'];
  graderTools: Array<Scalars['String']['output']>;
  limits: RlEnvironmentLimits;
  rounds: Array<RlEnvironmentRound>;
  solverTools: Array<Scalars['String']['output']>;
  task?: Maybe<RlTaskSummary>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RlEnvironmentCheck = {
  __typename?: 'RlEnvironmentCheck';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type RlEnvironmentFile = {
  __typename?: 'RlEnvironmentFile';
  content: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type RlEnvironmentFileInput = {
  content: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

/**
 * Per-template policy the sitting UI enforces client-side before the server
 * rejects an over-limit save.
 */
export type RlEnvironmentLimits = {
  __typename?: 'RlEnvironmentLimits';
  allowedGraderTools: Array<Scalars['String']['output']>;
  allowedSolverTools: Array<Scalars['String']['output']>;
  maxFileBytes: Scalars['Int']['output'];
  maxFiles: Scalars['Int']['output'];
  maxRounds: Scalars['Int']['output'];
  solverModel: Scalars['String']['output'];
};

/**
 * Post-submission feedback. Null while the evaluation pipeline is still
 * running, so the client polls.
 */
export type RlEnvironmentResult = {
  __typename?: 'RlEnvironmentResult';
  assessmentId: Scalars['ID']['output'];
  checks: Array<RlEnvironmentCheck>;
  components: Array<RlEnvironmentReviewComponent>;
  passed: Scalars['Boolean']['output'];
  rationale?: Maybe<Scalars['String']['output']>;
  roundCount: Scalars['Int']['output'];
  score?: Maybe<Scalars['Int']['output']>;
};

export type RlEnvironmentReviewComponent = {
  __typename?: 'RlEnvironmentReviewComponent';
  comment: Scalars['String']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type RlEnvironmentRound = {
  __typename?: 'RlEnvironmentRound';
  assessmentId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  graderResult?: Maybe<RlGraderResult>;
  id: Scalars['ID']['output'];
  latencyMs?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  roundNumber: Scalars['Int']['output'];
  solverOutput?: Maybe<Scalars['String']['output']>;
  solverTokensIn?: Maybe<Scalars['Int']['output']>;
  solverTokensOut?: Maybe<Scalars['Int']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: RlRoundStatus;
};

export type RlGraderCaseScore = {
  __typename?: 'RlGraderCaseScore';
  actual?: Maybe<Scalars['String']['output']>;
  expected?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type RlGraderResult = {
  __typename?: 'RlGraderResult';
  caseScores: Array<RlGraderCaseScore>;
  passed: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export enum RlRoundStatus {
  Failed = 'failed',
  Running = 'running',
  Succeeded = 'succeeded'
}

/**
 * The assigned task as the candidate may see it. Deliberately omits the
 * reviewer prompt and gold standard held on rl_task.
 */
export type RlTaskSummary = {
  __typename?: 'RlTaskSummary';
  brief: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  readme: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type StartAssessmentInput = {
  id: Scalars['ID']['input'];
};

export type SubmitCodeReviewCommentInput = {
  content: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  lineNumber: Scalars['Int']['input'];
  side: Scalars['String']['input'];
};

export type UpdateCodeReviewCommentInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpsertAssessmentFeedbackInput = {
  assessmentId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  isTechnicalDifficulty?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertRlEnvironmentInput = {
  files: Array<RlEnvironmentFileInput>;
  grader: Scalars['JSON']['input'];
  graderTools?: InputMaybe<Array<Scalars['String']['input']>>;
  solverTools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartAssessmentMutationVariables = Exact<{
  input: StartAssessmentInput;
}>;


export type StartAssessmentMutation = { __typename?: 'Mutation', startAssessment: string };

export type CompleteAssessmentMutationVariables = Exact<{
  input: CompleteAssessmentInput;
}>;


export type CompleteAssessmentMutation = { __typename?: 'Mutation', completeAssessment: string };

export type AuthenticateWithInviteCodeMutationVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type AuthenticateWithInviteCodeMutation = { __typename?: 'Mutation', authenticateWithInviteCode: { __typename?: 'AuthenticateWithInviteCodeResult', token: string } };

export type GetCodeReviewCommentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCodeReviewCommentsQuery = { __typename?: 'Query', getCodeReviewComments: Array<{ __typename?: 'CodeReviewComment', id: string, assessmentId: string, filename: string, lineNumber: number, side: string, content: string, createdAt: any, updatedAt: any }> };

export type SubmitCodeReviewCommentMutationVariables = Exact<{
  input: SubmitCodeReviewCommentInput;
}>;


export type SubmitCodeReviewCommentMutation = { __typename?: 'Mutation', submitCodeReviewComment: { __typename?: 'CodeReviewComment', id: string, assessmentId: string, filename: string, lineNumber: number, side: string, content: string, createdAt: any, updatedAt: any } };

export type UpdateCodeReviewCommentMutationVariables = Exact<{
  input: UpdateCodeReviewCommentInput;
}>;


export type UpdateCodeReviewCommentMutation = { __typename?: 'Mutation', updateCodeReviewComment: { __typename?: 'CodeReviewComment', id: string, assessmentId: string, filename: string, lineNumber: number, side: string, content: string, createdAt: any, updatedAt: any } };

export type DeleteCodeReviewCommentMutationVariables = Exact<{
  input: DeleteCodeReviewCommentInput;
}>;


export type DeleteCodeReviewCommentMutation = { __typename?: 'Mutation', deleteCodeReviewComment: string };

export type ExecuteCodeAgainstTestCasesQueryVariables = Exact<{
  input: ExecuteCodeAgainstTestCasesInput;
}>;


export type ExecuteCodeAgainstTestCasesQuery = { __typename?: 'Query', executeCodeAgainstTestCases: { __typename?: 'ExecutionResult', status: ExecutionStatus, stdout: string, stderr: string, exitCode: number } };

export type GetAssessmentFeedbackQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GetAssessmentFeedbackQuery = { __typename?: 'Query', assessmentFeedback?: { __typename?: 'AssessmentFeedback', rating?: number | null, comment?: string | null } | null };

export type GetAssessmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssessmentQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, args?: any | null, createdAt: any, startedAt?: any | null, completedAt?: any | null, template: { __typename?: 'AssessmentTemplate', id: string, name: string, description: string, duration?: number | null, templateType: AssessmentType, filteredAttributes?: any | null } } | null };

export type GetGitHubProvisioningQueryVariables = Exact<{
  input?: InputMaybe<GitHubProvisioningInput>;
}>;


export type GetGitHubProvisioningQuery = { __typename?: 'Query', gitHubProvisioning?: { __typename?: 'GitHubProvisioning', id: string, assessmentId: string, status: GitHubProvisioningStatus, repoName?: string | null, repoUrl?: string | null, errorMessage?: string | null, createdAt: any, updatedAt: any, commits: Array<{ __typename?: 'GitHubCommit', sha: string, author: string, date: any, message: string, latestWorkflowRun?: { __typename?: 'GitHubWorkflowRun', id: string, name: string, status: GitHubWorkflowRunStatus, conclusion?: GitHubWorkflowRunConclusion | null, url: string, createdAt: any, updatedAt: any } | null }> } | null };

export type GetLatestCodeExecutionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestCodeExecutionQuery = { __typename?: 'Query', getLatestCodeExecution?: { __typename?: 'CodeExecution', id: string, assessmentId: string, code: string, language: string, entrypoint?: string | null, status: string, passingTestCases: number, totalTestCases: number, createdAt: string, output: string } | null };

export type RlEnvironmentRoundFieldsFragment = { __typename?: 'RlEnvironmentRound', id: string, assessmentId: string, roundNumber: number, status: RlRoundStatus, model: string, solverOutput?: string | null, solverTokensIn?: number | null, solverTokensOut?: number | null, startedAt: any, completedAt?: any | null, latencyMs?: number | null, error?: string | null, graderResult?: { __typename?: 'RlGraderResult', passed: boolean, summary?: string | null, caseScores: Array<{ __typename?: 'RlGraderCaseScore', id: string, expected?: string | null, actual?: string | null, passed: boolean, reason?: string | null }> } | null };

export type GetRlEnvironmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRlEnvironmentQuery = { __typename?: 'Query', getRlEnvironment: { __typename?: 'RlEnvironment', assessmentId: string, grader: any, solverTools: Array<string>, graderTools: Array<string>, updatedAt: any, task?: { __typename?: 'RlTaskSummary', id: string, slug: string, name: string, domain: string, brief: string, sourceUrl?: string | null, readme: string, version: number } | null, files: Array<{ __typename?: 'RlEnvironmentFile', path: string, content: string }>, limits: { __typename?: 'RlEnvironmentLimits', solverModel: string, maxRounds: number, maxFiles: number, maxFileBytes: number, allowedSolverTools: Array<string>, allowedGraderTools: Array<string> }, rounds: Array<{ __typename?: 'RlEnvironmentRound', id: string, assessmentId: string, roundNumber: number, status: RlRoundStatus, model: string, solverOutput?: string | null, solverTokensIn?: number | null, solverTokensOut?: number | null, startedAt: any, completedAt?: any | null, latencyMs?: number | null, error?: string | null, graderResult?: { __typename?: 'RlGraderResult', passed: boolean, summary?: string | null, caseScores: Array<{ __typename?: 'RlGraderCaseScore', id: string, expected?: string | null, actual?: string | null, passed: boolean, reason?: string | null }> } | null }> } };

export type GetRlEnvironmentResultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRlEnvironmentResultQuery = { __typename?: 'Query', getRlEnvironmentResult?: { __typename?: 'RlEnvironmentResult', assessmentId: string, score?: number | null, passed: boolean, rationale?: string | null, roundCount: number, checks: Array<{ __typename?: 'RlEnvironmentCheck', id: string, label: string, passed: boolean }>, components: Array<{ __typename?: 'RlEnvironmentReviewComponent', name: string, score: number, comment: string }> } | null };

export type UpsertRlEnvironmentMutationVariables = Exact<{
  input: UpsertRlEnvironmentInput;
}>;


export type UpsertRlEnvironmentMutation = { __typename?: 'Mutation', upsertRlEnvironment: { __typename?: 'RlEnvironment', assessmentId: string, updatedAt: any } };

export type RunRlEnvironmentRoundMutationVariables = Exact<{ [key: string]: never; }>;


export type RunRlEnvironmentRoundMutation = { __typename?: 'Mutation', runRlEnvironmentRound: { __typename?: 'RlEnvironmentRound', id: string, assessmentId: string, roundNumber: number, status: RlRoundStatus, model: string, solverOutput?: string | null, solverTokensIn?: number | null, solverTokensOut?: number | null, startedAt: any, completedAt?: any | null, latencyMs?: number | null, error?: string | null, graderResult?: { __typename?: 'RlGraderResult', passed: boolean, summary?: string | null, caseScores: Array<{ __typename?: 'RlGraderCaseScore', id: string, expected?: string | null, actual?: string | null, passed: boolean, reason?: string | null }> } | null } };

export type UpsertAssessmentFeedbackMutationVariables = Exact<{
  input: UpsertAssessmentFeedbackInput;
}>;


export type UpsertAssessmentFeedbackMutation = { __typename?: 'Mutation', upsertAssessmentFeedback: { __typename?: 'AssessmentFeedback', id: string } };

export const RlEnvironmentRoundFieldsFragmentDoc = gql`
    fragment RlEnvironmentRoundFields on RlEnvironmentRound {
  id
  assessmentId
  roundNumber
  status
  model
  solverOutput
  solverTokensIn
  solverTokensOut
  graderResult {
    passed
    summary
    caseScores {
      id
      expected
      actual
      passed
      reason
    }
  }
  startedAt
  completedAt
  latencyMs
  error
}
    `;
export const StartAssessmentDocument = gql`
    mutation StartAssessment($input: StartAssessmentInput!) {
  startAssessment(input: $input)
}
    `;
export type StartAssessmentMutationFn = Apollo.MutationFunction<StartAssessmentMutation, StartAssessmentMutationVariables>;

/**
 * __useStartAssessmentMutation__
 *
 * To run a mutation, you first call `useStartAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAssessmentMutation, { data, loading, error }] = useStartAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartAssessmentMutation, StartAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAssessmentMutation, StartAssessmentMutationVariables>(StartAssessmentDocument, options);
      }
export type StartAssessmentMutationHookResult = ReturnType<typeof useStartAssessmentMutation>;
export type StartAssessmentMutationResult = Apollo.MutationResult<StartAssessmentMutation>;
export type StartAssessmentMutationOptions = Apollo.BaseMutationOptions<StartAssessmentMutation, StartAssessmentMutationVariables>;
export const CompleteAssessmentDocument = gql`
    mutation CompleteAssessment($input: CompleteAssessmentInput!) {
  completeAssessment(input: $input)
}
    `;
export type CompleteAssessmentMutationFn = Apollo.MutationFunction<CompleteAssessmentMutation, CompleteAssessmentMutationVariables>;

/**
 * __useCompleteAssessmentMutation__
 *
 * To run a mutation, you first call `useCompleteAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAssessmentMutation, { data, loading, error }] = useCompleteAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAssessmentMutation, CompleteAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAssessmentMutation, CompleteAssessmentMutationVariables>(CompleteAssessmentDocument, options);
      }
export type CompleteAssessmentMutationHookResult = ReturnType<typeof useCompleteAssessmentMutation>;
export type CompleteAssessmentMutationResult = Apollo.MutationResult<CompleteAssessmentMutation>;
export type CompleteAssessmentMutationOptions = Apollo.BaseMutationOptions<CompleteAssessmentMutation, CompleteAssessmentMutationVariables>;
export const AuthenticateWithInviteCodeDocument = gql`
    mutation AuthenticateWithInviteCode($inviteCode: String!) {
  authenticateWithInviteCode(inviteCode: $inviteCode) {
    token
  }
}
    `;
export type AuthenticateWithInviteCodeMutationFn = Apollo.MutationFunction<AuthenticateWithInviteCodeMutation, AuthenticateWithInviteCodeMutationVariables>;

/**
 * __useAuthenticateWithInviteCodeMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithInviteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithInviteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithInviteCodeMutation, { data, loading, error }] = useAuthenticateWithInviteCodeMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useAuthenticateWithInviteCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithInviteCodeMutation, AuthenticateWithInviteCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithInviteCodeMutation, AuthenticateWithInviteCodeMutationVariables>(AuthenticateWithInviteCodeDocument, options);
      }
export type AuthenticateWithInviteCodeMutationHookResult = ReturnType<typeof useAuthenticateWithInviteCodeMutation>;
export type AuthenticateWithInviteCodeMutationResult = Apollo.MutationResult<AuthenticateWithInviteCodeMutation>;
export type AuthenticateWithInviteCodeMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithInviteCodeMutation, AuthenticateWithInviteCodeMutationVariables>;
export const GetCodeReviewCommentsDocument = gql`
    query GetCodeReviewComments {
  getCodeReviewComments {
    id
    assessmentId
    filename
    lineNumber
    side
    content
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCodeReviewCommentsQuery__
 *
 * To run a query within a React component, call `useGetCodeReviewCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCodeReviewCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCodeReviewCommentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCodeReviewCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>(GetCodeReviewCommentsDocument, options);
      }
export function useGetCodeReviewCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>(GetCodeReviewCommentsDocument, options);
        }
// @ts-ignore
export function useGetCodeReviewCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>;
export function useGetCodeReviewCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCodeReviewCommentsQuery | undefined, GetCodeReviewCommentsQueryVariables>;
export function useGetCodeReviewCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>(GetCodeReviewCommentsDocument, options);
        }
export type GetCodeReviewCommentsQueryHookResult = ReturnType<typeof useGetCodeReviewCommentsQuery>;
export type GetCodeReviewCommentsLazyQueryHookResult = ReturnType<typeof useGetCodeReviewCommentsLazyQuery>;
export type GetCodeReviewCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCodeReviewCommentsSuspenseQuery>;
export type GetCodeReviewCommentsQueryResult = Apollo.QueryResult<GetCodeReviewCommentsQuery, GetCodeReviewCommentsQueryVariables>;
export const SubmitCodeReviewCommentDocument = gql`
    mutation SubmitCodeReviewComment($input: SubmitCodeReviewCommentInput!) {
  submitCodeReviewComment(input: $input) {
    id
    assessmentId
    filename
    lineNumber
    side
    content
    createdAt
    updatedAt
  }
}
    `;
export type SubmitCodeReviewCommentMutationFn = Apollo.MutationFunction<SubmitCodeReviewCommentMutation, SubmitCodeReviewCommentMutationVariables>;

/**
 * __useSubmitCodeReviewCommentMutation__
 *
 * To run a mutation, you first call `useSubmitCodeReviewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCodeReviewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCodeReviewCommentMutation, { data, loading, error }] = useSubmitCodeReviewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCodeReviewCommentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCodeReviewCommentMutation, SubmitCodeReviewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCodeReviewCommentMutation, SubmitCodeReviewCommentMutationVariables>(SubmitCodeReviewCommentDocument, options);
      }
export type SubmitCodeReviewCommentMutationHookResult = ReturnType<typeof useSubmitCodeReviewCommentMutation>;
export type SubmitCodeReviewCommentMutationResult = Apollo.MutationResult<SubmitCodeReviewCommentMutation>;
export type SubmitCodeReviewCommentMutationOptions = Apollo.BaseMutationOptions<SubmitCodeReviewCommentMutation, SubmitCodeReviewCommentMutationVariables>;
export const UpdateCodeReviewCommentDocument = gql`
    mutation UpdateCodeReviewComment($input: UpdateCodeReviewCommentInput!) {
  updateCodeReviewComment(input: $input) {
    id
    assessmentId
    filename
    lineNumber
    side
    content
    createdAt
    updatedAt
  }
}
    `;
export type UpdateCodeReviewCommentMutationFn = Apollo.MutationFunction<UpdateCodeReviewCommentMutation, UpdateCodeReviewCommentMutationVariables>;

/**
 * __useUpdateCodeReviewCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCodeReviewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCodeReviewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCodeReviewCommentMutation, { data, loading, error }] = useUpdateCodeReviewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCodeReviewCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCodeReviewCommentMutation, UpdateCodeReviewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCodeReviewCommentMutation, UpdateCodeReviewCommentMutationVariables>(UpdateCodeReviewCommentDocument, options);
      }
export type UpdateCodeReviewCommentMutationHookResult = ReturnType<typeof useUpdateCodeReviewCommentMutation>;
export type UpdateCodeReviewCommentMutationResult = Apollo.MutationResult<UpdateCodeReviewCommentMutation>;
export type UpdateCodeReviewCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCodeReviewCommentMutation, UpdateCodeReviewCommentMutationVariables>;
export const DeleteCodeReviewCommentDocument = gql`
    mutation DeleteCodeReviewComment($input: DeleteCodeReviewCommentInput!) {
  deleteCodeReviewComment(input: $input)
}
    `;
export type DeleteCodeReviewCommentMutationFn = Apollo.MutationFunction<DeleteCodeReviewCommentMutation, DeleteCodeReviewCommentMutationVariables>;

/**
 * __useDeleteCodeReviewCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCodeReviewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCodeReviewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCodeReviewCommentMutation, { data, loading, error }] = useDeleteCodeReviewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCodeReviewCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCodeReviewCommentMutation, DeleteCodeReviewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCodeReviewCommentMutation, DeleteCodeReviewCommentMutationVariables>(DeleteCodeReviewCommentDocument, options);
      }
export type DeleteCodeReviewCommentMutationHookResult = ReturnType<typeof useDeleteCodeReviewCommentMutation>;
export type DeleteCodeReviewCommentMutationResult = Apollo.MutationResult<DeleteCodeReviewCommentMutation>;
export type DeleteCodeReviewCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCodeReviewCommentMutation, DeleteCodeReviewCommentMutationVariables>;
export const ExecuteCodeAgainstTestCasesDocument = gql`
    query ExecuteCodeAgainstTestCases($input: ExecuteCodeAgainstTestCasesInput!) {
  executeCodeAgainstTestCases(input: $input) {
    status
    stdout
    stderr
    exitCode
  }
}
    `;

/**
 * __useExecuteCodeAgainstTestCasesQuery__
 *
 * To run a query within a React component, call `useExecuteCodeAgainstTestCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteCodeAgainstTestCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteCodeAgainstTestCasesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteCodeAgainstTestCasesQuery(baseOptions: Apollo.QueryHookOptions<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables> & ({ variables: ExecuteCodeAgainstTestCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>(ExecuteCodeAgainstTestCasesDocument, options);
      }
export function useExecuteCodeAgainstTestCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>(ExecuteCodeAgainstTestCasesDocument, options);
        }
// @ts-ignore
export function useExecuteCodeAgainstTestCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>;
export function useExecuteCodeAgainstTestCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteCodeAgainstTestCasesQuery | undefined, ExecuteCodeAgainstTestCasesQueryVariables>;
export function useExecuteCodeAgainstTestCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>(ExecuteCodeAgainstTestCasesDocument, options);
        }
export type ExecuteCodeAgainstTestCasesQueryHookResult = ReturnType<typeof useExecuteCodeAgainstTestCasesQuery>;
export type ExecuteCodeAgainstTestCasesLazyQueryHookResult = ReturnType<typeof useExecuteCodeAgainstTestCasesLazyQuery>;
export type ExecuteCodeAgainstTestCasesSuspenseQueryHookResult = ReturnType<typeof useExecuteCodeAgainstTestCasesSuspenseQuery>;
export type ExecuteCodeAgainstTestCasesQueryResult = Apollo.QueryResult<ExecuteCodeAgainstTestCasesQuery, ExecuteCodeAgainstTestCasesQueryVariables>;
export const GetAssessmentFeedbackDocument = gql`
    query GetAssessmentFeedback($assessmentId: ID!) {
  assessmentFeedback(assessmentId: $assessmentId) {
    rating
    comment
  }
}
    `;

/**
 * __useGetAssessmentFeedbackQuery__
 *
 * To run a query within a React component, call `useGetAssessmentFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentFeedbackQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetAssessmentFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables> & ({ variables: GetAssessmentFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>(GetAssessmentFeedbackDocument, options);
      }
export function useGetAssessmentFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>(GetAssessmentFeedbackDocument, options);
        }
// @ts-ignore
export function useGetAssessmentFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>;
export function useGetAssessmentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentFeedbackQuery | undefined, GetAssessmentFeedbackQueryVariables>;
export function useGetAssessmentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>(GetAssessmentFeedbackDocument, options);
        }
export type GetAssessmentFeedbackQueryHookResult = ReturnType<typeof useGetAssessmentFeedbackQuery>;
export type GetAssessmentFeedbackLazyQueryHookResult = ReturnType<typeof useGetAssessmentFeedbackLazyQuery>;
export type GetAssessmentFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentFeedbackSuspenseQuery>;
export type GetAssessmentFeedbackQueryResult = Apollo.QueryResult<GetAssessmentFeedbackQuery, GetAssessmentFeedbackQueryVariables>;
export const GetAssessmentDocument = gql`
    query GetAssessment($id: ID!) {
  assessment(id: $id) {
    id
    args
    createdAt
    startedAt
    completedAt
    template {
      id
      name
      description
      duration
      templateType
      filteredAttributes
    }
  }
}
    `;

/**
 * __useGetAssessmentQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables> & ({ variables: GetAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentQuery, GetAssessmentQueryVariables>(GetAssessmentDocument, options);
      }
export function useGetAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentQuery, GetAssessmentQueryVariables>(GetAssessmentDocument, options);
        }
// @ts-ignore
export function useGetAssessmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentQuery, GetAssessmentQueryVariables>;
export function useGetAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentQuery | undefined, GetAssessmentQueryVariables>;
export function useGetAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentQuery, GetAssessmentQueryVariables>(GetAssessmentDocument, options);
        }
export type GetAssessmentQueryHookResult = ReturnType<typeof useGetAssessmentQuery>;
export type GetAssessmentLazyQueryHookResult = ReturnType<typeof useGetAssessmentLazyQuery>;
export type GetAssessmentSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentSuspenseQuery>;
export type GetAssessmentQueryResult = Apollo.QueryResult<GetAssessmentQuery, GetAssessmentQueryVariables>;
export const GetGitHubProvisioningDocument = gql`
    query GetGitHubProvisioning($input: GitHubProvisioningInput) {
  gitHubProvisioning(input: $input) {
    id
    assessmentId
    status
    repoName
    repoUrl
    errorMessage
    commits {
      sha
      author
      date
      message
      latestWorkflowRun {
        id
        name
        status
        conclusion
        url
        createdAt
        updatedAt
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGitHubProvisioningQuery__
 *
 * To run a query within a React component, call `useGetGitHubProvisioningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGitHubProvisioningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGitHubProvisioningQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGitHubProvisioningQuery(baseOptions?: Apollo.QueryHookOptions<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>(GetGitHubProvisioningDocument, options);
      }
export function useGetGitHubProvisioningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>(GetGitHubProvisioningDocument, options);
        }
// @ts-ignore
export function useGetGitHubProvisioningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>): Apollo.UseSuspenseQueryResult<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>;
export function useGetGitHubProvisioningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>): Apollo.UseSuspenseQueryResult<GetGitHubProvisioningQuery | undefined, GetGitHubProvisioningQueryVariables>;
export function useGetGitHubProvisioningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>(GetGitHubProvisioningDocument, options);
        }
export type GetGitHubProvisioningQueryHookResult = ReturnType<typeof useGetGitHubProvisioningQuery>;
export type GetGitHubProvisioningLazyQueryHookResult = ReturnType<typeof useGetGitHubProvisioningLazyQuery>;
export type GetGitHubProvisioningSuspenseQueryHookResult = ReturnType<typeof useGetGitHubProvisioningSuspenseQuery>;
export type GetGitHubProvisioningQueryResult = Apollo.QueryResult<GetGitHubProvisioningQuery, GetGitHubProvisioningQueryVariables>;
export const GetLatestCodeExecutionDocument = gql`
    query GetLatestCodeExecution {
  getLatestCodeExecution {
    id
    assessmentId
    code
    language
    entrypoint
    status
    passingTestCases
    totalTestCases
    createdAt
    output
  }
}
    `;

/**
 * __useGetLatestCodeExecutionQuery__
 *
 * To run a query within a React component, call `useGetLatestCodeExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestCodeExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestCodeExecutionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestCodeExecutionQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>(GetLatestCodeExecutionDocument, options);
      }
export function useGetLatestCodeExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>(GetLatestCodeExecutionDocument, options);
        }
// @ts-ignore
export function useGetLatestCodeExecutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>;
export function useGetLatestCodeExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestCodeExecutionQuery | undefined, GetLatestCodeExecutionQueryVariables>;
export function useGetLatestCodeExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>(GetLatestCodeExecutionDocument, options);
        }
export type GetLatestCodeExecutionQueryHookResult = ReturnType<typeof useGetLatestCodeExecutionQuery>;
export type GetLatestCodeExecutionLazyQueryHookResult = ReturnType<typeof useGetLatestCodeExecutionLazyQuery>;
export type GetLatestCodeExecutionSuspenseQueryHookResult = ReturnType<typeof useGetLatestCodeExecutionSuspenseQuery>;
export type GetLatestCodeExecutionQueryResult = Apollo.QueryResult<GetLatestCodeExecutionQuery, GetLatestCodeExecutionQueryVariables>;
export const GetRlEnvironmentDocument = gql`
    query GetRlEnvironment {
  getRlEnvironment {
    assessmentId
    task {
      id
      slug
      name
      domain
      brief
      sourceUrl
      readme
      version
    }
    files {
      path
      content
    }
    grader
    solverTools
    graderTools
    limits {
      solverModel
      maxRounds
      maxFiles
      maxFileBytes
      allowedSolverTools
      allowedGraderTools
    }
    updatedAt
    rounds {
      ...RlEnvironmentRoundFields
    }
  }
}
    ${RlEnvironmentRoundFieldsFragmentDoc}`;

/**
 * __useGetRlEnvironmentQuery__
 *
 * To run a query within a React component, call `useGetRlEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRlEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRlEnvironmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRlEnvironmentQuery(baseOptions?: Apollo.QueryHookOptions<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>(GetRlEnvironmentDocument, options);
      }
export function useGetRlEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>(GetRlEnvironmentDocument, options);
        }
// @ts-ignore
export function useGetRlEnvironmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>;
export function useGetRlEnvironmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetRlEnvironmentQuery | undefined, GetRlEnvironmentQueryVariables>;
export function useGetRlEnvironmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>(GetRlEnvironmentDocument, options);
        }
export type GetRlEnvironmentQueryHookResult = ReturnType<typeof useGetRlEnvironmentQuery>;
export type GetRlEnvironmentLazyQueryHookResult = ReturnType<typeof useGetRlEnvironmentLazyQuery>;
export type GetRlEnvironmentSuspenseQueryHookResult = ReturnType<typeof useGetRlEnvironmentSuspenseQuery>;
export type GetRlEnvironmentQueryResult = Apollo.QueryResult<GetRlEnvironmentQuery, GetRlEnvironmentQueryVariables>;
export const GetRlEnvironmentResultDocument = gql`
    query GetRlEnvironmentResult {
  getRlEnvironmentResult {
    assessmentId
    score
    passed
    rationale
    checks {
      id
      label
      passed
    }
    components {
      name
      score
      comment
    }
    roundCount
  }
}
    `;

/**
 * __useGetRlEnvironmentResultQuery__
 *
 * To run a query within a React component, call `useGetRlEnvironmentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRlEnvironmentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRlEnvironmentResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRlEnvironmentResultQuery(baseOptions?: Apollo.QueryHookOptions<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>(GetRlEnvironmentResultDocument, options);
      }
export function useGetRlEnvironmentResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>(GetRlEnvironmentResultDocument, options);
        }
// @ts-ignore
export function useGetRlEnvironmentResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>;
export function useGetRlEnvironmentResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetRlEnvironmentResultQuery | undefined, GetRlEnvironmentResultQueryVariables>;
export function useGetRlEnvironmentResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>(GetRlEnvironmentResultDocument, options);
        }
export type GetRlEnvironmentResultQueryHookResult = ReturnType<typeof useGetRlEnvironmentResultQuery>;
export type GetRlEnvironmentResultLazyQueryHookResult = ReturnType<typeof useGetRlEnvironmentResultLazyQuery>;
export type GetRlEnvironmentResultSuspenseQueryHookResult = ReturnType<typeof useGetRlEnvironmentResultSuspenseQuery>;
export type GetRlEnvironmentResultQueryResult = Apollo.QueryResult<GetRlEnvironmentResultQuery, GetRlEnvironmentResultQueryVariables>;
export const UpsertRlEnvironmentDocument = gql`
    mutation UpsertRlEnvironment($input: UpsertRlEnvironmentInput!) {
  upsertRlEnvironment(input: $input) {
    assessmentId
    updatedAt
  }
}
    `;
export type UpsertRlEnvironmentMutationFn = Apollo.MutationFunction<UpsertRlEnvironmentMutation, UpsertRlEnvironmentMutationVariables>;

/**
 * __useUpsertRlEnvironmentMutation__
 *
 * To run a mutation, you first call `useUpsertRlEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRlEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRlEnvironmentMutation, { data, loading, error }] = useUpsertRlEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRlEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRlEnvironmentMutation, UpsertRlEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRlEnvironmentMutation, UpsertRlEnvironmentMutationVariables>(UpsertRlEnvironmentDocument, options);
      }
export type UpsertRlEnvironmentMutationHookResult = ReturnType<typeof useUpsertRlEnvironmentMutation>;
export type UpsertRlEnvironmentMutationResult = Apollo.MutationResult<UpsertRlEnvironmentMutation>;
export type UpsertRlEnvironmentMutationOptions = Apollo.BaseMutationOptions<UpsertRlEnvironmentMutation, UpsertRlEnvironmentMutationVariables>;
export const RunRlEnvironmentRoundDocument = gql`
    mutation RunRlEnvironmentRound {
  runRlEnvironmentRound {
    ...RlEnvironmentRoundFields
  }
}
    ${RlEnvironmentRoundFieldsFragmentDoc}`;
export type RunRlEnvironmentRoundMutationFn = Apollo.MutationFunction<RunRlEnvironmentRoundMutation, RunRlEnvironmentRoundMutationVariables>;

/**
 * __useRunRlEnvironmentRoundMutation__
 *
 * To run a mutation, you first call `useRunRlEnvironmentRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunRlEnvironmentRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runRlEnvironmentRoundMutation, { data, loading, error }] = useRunRlEnvironmentRoundMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunRlEnvironmentRoundMutation(baseOptions?: Apollo.MutationHookOptions<RunRlEnvironmentRoundMutation, RunRlEnvironmentRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunRlEnvironmentRoundMutation, RunRlEnvironmentRoundMutationVariables>(RunRlEnvironmentRoundDocument, options);
      }
export type RunRlEnvironmentRoundMutationHookResult = ReturnType<typeof useRunRlEnvironmentRoundMutation>;
export type RunRlEnvironmentRoundMutationResult = Apollo.MutationResult<RunRlEnvironmentRoundMutation>;
export type RunRlEnvironmentRoundMutationOptions = Apollo.BaseMutationOptions<RunRlEnvironmentRoundMutation, RunRlEnvironmentRoundMutationVariables>;
export const UpsertAssessmentFeedbackDocument = gql`
    mutation UpsertAssessmentFeedback($input: UpsertAssessmentFeedbackInput!) {
  upsertAssessmentFeedback(input: $input) {
    id
  }
}
    `;
export type UpsertAssessmentFeedbackMutationFn = Apollo.MutationFunction<UpsertAssessmentFeedbackMutation, UpsertAssessmentFeedbackMutationVariables>;

/**
 * __useUpsertAssessmentFeedbackMutation__
 *
 * To run a mutation, you first call `useUpsertAssessmentFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssessmentFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssessmentFeedbackMutation, { data, loading, error }] = useUpsertAssessmentFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAssessmentFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssessmentFeedbackMutation, UpsertAssessmentFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssessmentFeedbackMutation, UpsertAssessmentFeedbackMutationVariables>(UpsertAssessmentFeedbackDocument, options);
      }
export type UpsertAssessmentFeedbackMutationHookResult = ReturnType<typeof useUpsertAssessmentFeedbackMutation>;
export type UpsertAssessmentFeedbackMutationResult = Apollo.MutationResult<UpsertAssessmentFeedbackMutation>;
export type UpsertAssessmentFeedbackMutationOptions = Apollo.BaseMutationOptions<UpsertAssessmentFeedbackMutation, UpsertAssessmentFeedbackMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    